import { ShotFromGroup } from 'store'

export enum TimelineTabs {
  AI_FRAME_VIEW = 'AI-Frame View',
  AUTO_CYCLE_VIEW = 'Auto-Cycle View',
  IN_OUT_VIEW = 'In-Out View'
}
// export const timelineTabs = ['AI-Frame View', 'Auto-Cycle View', 'In-Out View']

export const defaultThumbObject: Thumbnail = {
  frame: null, isEven: false, title: '', shot: null
}
export const numberOfThumbnailsToView = 11

export interface Thumbnail {
  frame: number
  isEven: boolean
  title: string
  shot: ShotFromGroup
}
